import {ChangeDetectorRef, Directive, ElementRef, EventEmitter, HostListener, Inject, Optional, Output, Renderer2, Self, ViewContainerRef} from "@angular/core";
import {FormControlName} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {LoadingState} from "../state/loading-state.service";
import {InputDirective} from "../input.directive";
import {InputType} from "../root/input-type";

@Directive({
  selector: "input[valgInputSearch]",
  providers: [{ provide: InputType, useExisting: InputSearchDirective }]
})
export class InputSearchDirective extends InputDirective  {
  @Output() searchEvent: EventEmitter<HTMLInputElement> = new EventEmitter<HTMLInputElement>();
  private readonly searchInputClass = 'valg-input__search';
  protected _elementClass: string[] = [ this.searchInputClass ];

  constructor(
    @Optional() @Self() @Inject(FormControlName) protected override formControl: FormControlName,
    protected override cdr: ChangeDetectorRef,
    protected override elementRef: ElementRef<HTMLInputElement>,
    protected override renderer: Renderer2,
    protected override translate: TranslateService,
    protected override loadingState: LoadingState,
    protected viewContainerRef: ViewContainerRef,
  ){
      super(formControl, cdr, elementRef, renderer, translate, loadingState);
      this.renderer.addClass(this.elementRef.nativeElement, 'valg-input__search');
  }

  @HostListener('keydown.enter')
  onEnterClicked() {
    this.performSubmit();
  }

  performSubmit() {
    this.searchEvent.emit(this.elementRef.nativeElement);
  }

  getPasteListener(){
    return this.renderer.listen(this.elementRef.nativeElement, 'paste', (event) => {
      event.preventDefault();
      const readPasteValue = event.clipboardData?.getData('text').replace(/\s+/g, ' ').trim();
      if (readPasteValue !== undefined) {
        this.insertPasteText(this.elementRef.nativeElement, readPasteValue);
        this.formControl.control.markAsDirty();
      }
    });
  }

  protected insertPasteText(element: HTMLInputElement, pasteText: string) {
    this.formControl.control.setValue(this.pasteFormat(element, pasteText));
  }

  public pasteFormat(element: HTMLInputElement, pasteText: string) {
    const oldValue = element.value;
    const oldCursorStart = element.selectionStart ?? 0;
    const oldCursorEnd = element.selectionEnd ?? 0;

    const newValue = oldValue.substring(0, oldCursorStart) + pasteText + oldValue.substring(oldCursorEnd);
    const newCursorPosition = oldCursorStart + pasteText.length;

    element.selectionStart = newCursorPosition;
    element.selectionEnd = newCursorPosition;
    return newValue;
  }

}